export default __webpack_public_path__ + "static/media/View.c39b1946.svg";